import { useState } from 'react';
import { appActions } from '../../store/app/slice';
import { ErrorContent } from './ErrorContent/ErrorContent';
import { FormContent } from './FormContent/FormContent';
import { SuccessContent } from './SuccessContent/SuccessContent';
import { Modal } from 'components';
import { useDispatch } from 'store/utils';

export const CreateUserModal = () => {
  const [userCreated, setUserCreated] = useState(false);
  const [displayErrorModal, setDisplayErrorModal] = useState(false);
  const [userEmail, setUserEmail] = useState('');

  const dispatch = useDispatch();

  const close = () => {
    dispatch(appActions.setIsModalOpened({ name: 'createUser', isOpened: false }));
  };

  return (
    <Modal title={'Create a new user'} onClose={close}>
      {displayErrorModal ? (
        <ErrorContent onConfirm={close} />
      ) : userCreated ? (
        <SuccessContent onClose={close} email={userEmail} />
      ) : (
        <FormContent
          setUserEmail={setUserEmail}
          setShowModalError={setDisplayErrorModal}
          setUserCreated={setUserCreated}
        />
      )}
    </Modal>
  );
};
